import { makeStyles } from '@material-ui/core/styles';
import { CheckRounded as CheckIcon } from '@material-ui/icons';
import { StepIconProps } from '@material-ui/core/StepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 28,
    height: 28,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[700],
  },
  reached: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
  },
  checkIcon: {
    fontSize: 18,
  },
}));

// MUI dessine des ronds par défaut : ce composant les remplace par des carrés à coin adouci,
// dans le bleu de l'admin dès que l'étape est atteinte.
export default function SquareStepIcon({ active, completed, icon }: StepIconProps) {
  const classes = useStyles();
  const isReached = Boolean(active) || Boolean(completed);

  return (
    <div className={`${classes.root} ${isReached ? classes.reached : ''}`}>
      {completed ? <CheckIcon className={classes.checkIcon} /> : icon}
    </div>
  );
}
